import PropTypes from 'prop-types';
export default {
  src: PropTypes.string.isRequired,
  srcThumb: PropTypes.string,
  srcHighDef: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['PHOTO', 'VIDEO', 'VIRTUAL_TOUR', 'FLOORPLAN']).isRequired
};